/** FAQ content tuned for Saudi contracting search intent (EN + AR) — powers visible accordions & FAQ schema */

export const HOME_FAQ = {
  en: [
    {
      q: 'What contracting services does Q-Tech offer in Saudi Arabia?',
      a: 'Q-Tech Contracting provides civil works, mechanical contracting, electrical and instrumentation (E&I), insulation, boiler and combustion systems, and industrial construction across Al Khobar, Dammam, Jubail, Yanbu, Ras Al-Khair, and the wider Kingdom.',
    },
    {
      q: 'Where is Q-Tech Contracting located?',
      a: 'Our headquarters is in Al Buhairah, Al Khobar 34722, Eastern Province, Saudi Arabia. We mobilize teams across the Eastern and Western regions for government and private sector projects.',
    },
    {
      q: 'Is Q-Tech a Saudi contracting company?',
      a: 'Yes. Q-Tech Contracting is a Saudi-owned general contractor established in 2023 under Al Dawood Holding Group, with group operations in Saudi Arabia since 1998.',
    },
    {
      q: 'Which industries does Q-Tech serve?',
      a: 'We deliver construction and contracting for oil & gas, petrochemical, industrial, infrastructure, and commercial clients — including fast-track, occupied-site, and limited-access programmes.',
    },
    {
      q: 'How do I request a construction quote in Saudi Arabia?',
      a: 'Contact us by phone at +966 53 290 0988, email info@aldawood.net, or use the contact form on our website. Share your scope, location, and timeline for a tailored proposal.',
    },
  ],
  ar: [
    {
      q: 'ما هي خدمات المقاولات التي تقدمها كيو-تك في السعودية؟',
      a: 'تقدم كيو-تك للمقاولات أعمالاً مدنية ومقاولات ميكانيكية وكهربائية وأجهزة قياس وعزل وغلايات وإنشاءات صناعية في الخبر والدمام والجبيل وينبع ورأس الخير وجميع أنحاء المملكة.',
    },
    {
      q: 'أين يقع مقر كيو-تك للمقاولات؟',
      a: 'يقع مقرنا في البحيرة، الخبر 34722، المنطقة الشرقية، المملكة العربية السعودية. نعبئ فرقاً في المنطقتين الشرقية والغربية لمشاريع القطاعين الحكومي والخاص.',
    },
    {
      q: 'هل كيو-تك شركة مقاولات سعودية؟',
      a: 'نعم. كيو-تك للمقاولات شركة مقاولات عامة سعودية تأسست عام 2023م تحت مظلة مجموعة آل داوود القابضة، التي تعمل في المملكة منذ عام 1998م.',
    },
    {
      q: 'ما القطاعات التي تخدمها كيو-تك؟',
      a: 'ننفذ مشاريع إنشاءات ومقاولات لقطاعات النفط والغاز والبتروكيماويات والصناعة والبنية التحتية والتجارية — بما في ذلك البرامج السريعة والمواقع المأهولة.',
    },
    {
      q: 'كيف أطلب عرض سعر لمشروع مقاولات في السعودية؟',
      a: 'تواصل معنا على +966532900988 أو info@aldawood.net أو عبر نموذج الاتصال في الموقع. شاركنا نطاق العمل والموقع والجدول الزمني لعرض سعر مخصص.',
    },
  ],
};

export const SERVICES_FAQ = {
  en: [
    {
      q: 'What is included in Q-Tech general contracting services?',
      a: 'Our services cover civil works, structural and infrastructure construction, mechanical piping and equipment installation, electrical and instrumentation, insulation, boilers, and full industrial facility construction across Saudi Arabia.',
    },
    {
      q: 'Does Q-Tech provide MEP contracting in the Eastern Province?',
      a: 'Yes. We deliver mechanical, electrical, and plumbing/instrumentation (MEP & E&I) contracting from Al Khobar to Jubail, Dammam, and industrial cities across the Eastern Province.',
    },
    {
      q: 'Can Q-Tech handle industrial shutdown and fast-track projects?',
      a: 'Yes. Our teams specialize in time-critical industrial outages, occupied facilities, and fast-track programmes with HSE leadership and daily progress reporting.',
    },
  ],
  ar: [
    {
      q: 'ماذا تشمل خدمات المقاولات العامة لدى كيو-تك؟',
      a: 'تشمل خدماتنا أعمالاً مدنية وإنشاءات وبنية تحتية وتركيبات ميكانيكية وكهربائية وأجهزة قياس وعزل وغلايات وإنشاءات منشآت صناعية في جميع أنحاء المملكة.',
    },
    {
      q: 'هل تقدم كيو-تك مقاولات MEP في المنطقة الشرقية؟',
      a: 'نعم. ننفذ أعمال ميكانيكية وكهربائية وأجهزة قياس (MEP وE&I) من الخبر إلى الجبيل والدمام والمدن الصناعية في المنطقة الشرقية.',
    },
    {
      q: 'هل يمكن لكيو-تك تنفيذ مشاريع صيانة سريعة وإيقاف تشغيل صناعي؟',
      a: 'نعم. تتخصص فرقنا في إيقاف التشغيل الصناعي الحساس زمنياً والمواقع المأهولة والبرامج السريعة مع قيادة HSE وتقارير تقدم يومية.',
    },
  ],
};

export const CONTACT_FAQ = {
  en: [
    {
      q: 'How can I contact Q-Tech Contracting in Al Khobar?',
      a: 'Visit us at 7783 King Khalid Rd, Al Buhairah, Al Khobar 34722. Call +966 53 290 0988 or +966 50 051 9974, email info@aldawood.net, or submit the contact form on qtechcontracting.com/contact.',
    },
    {
      q: 'What are Q-Tech office hours in Saudi Arabia?',
      a: 'Our Al Khobar office is open Monday to Saturday, 9:00 AM to 6:00 PM (Saudi Arabia time).',
    },
  ],
  ar: [
    {
      q: 'كيف أتواصل مع كيو-تك للمقاولات في الخبر؟',
      a: 'زرنا في 7783 طريق الملك خالد، البحيرة، الخبر 34722. اتصل على +966532900988 أو +966500519974 أو راسل info@aldawood.net أو أرسل النموذج في qtechcontracting.com/contact.',
    },
    {
      q: 'ما هي ساعات عمل مكتب كيو-تك في السعودية؟',
      a: 'مكتب الخبر مفتوح من الإثنين إلى السبت، 9:00 صباحاً حتى 6:00 مساءً (توقيت السعودية).',
    },
  ],
};

export const PAGE_FAQ = {
  home: HOME_FAQ,
  services: SERVICES_FAQ,
  contact: CONTACT_FAQ,
};
